import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { SIGNAL_BLANKING_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { SIGNAL_BLANKING_REPORT } from "../interfaces/dashboard";

export default function SignalBlanking() {
    const signalBlankingReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.SIGNAL_BLANKING_REPORT;

    const [signalBlankingReportTableData, setSignalBlankingReportTableData] = useState<SIGNAL_BLANKING_REPORT[]>([]);

    useEffect(() => {
        setSignalBlankingReportTableData(SIGNAL_BLANKING_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="SIGNAL_BLANKING"
        tableColumns={signalBlankingReportTableColumns}
        tableData={signalBlankingReportTableData} />
    );
}